import React from "react";
import { Link } from "react-router-dom";

const BannerOne = () => {
  return (
    <section className="banner-area banner-bg">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="banner-img wow fadeInLeft" data-wow-delay=".4s">
              <img src="/img/banner/banner_img.png" alt="Klassieke banken en stoelen voor stofferen" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="banner-content">
              <span className="sub-title wow fadeInUp" data-wow-delay=".2s">
                Vakmanschap In Stoffering
              </span>
              <h1 className="title wow fadeInUp" data-wow-delay=".4s">
                Geef Uw Meubels een Tweede Leven
              </h1>
              <p className="description wow fadeInUp" data-wow-delay=".5s">
                Specialist in herstofferen van banken, stoelen en interieurs. 
                Hoogwaardige stoffen, ambachtelijk vakwerk en duurzaam resultaat.
              </p>
              <Link
              to="/contact"
              className="btn wow fadeInUp"
              data-wow-delay=".6s"
              aria-label="Vraag een Gratis Offerte Aan"
              >
              Vraag een Gratis Offerte Aan <span></span>
            </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="banner-shape-wrap">
        <img src="/img/banner/banner_shape01.png" alt="Decoratieve vorm element" />
        <img src="/img/banner/banner_shape02.png" alt="Decoratieve vorm element" className="animationFramesOne" />
        {/* <img src="/img/banner/banner_shape03.png" alt="Decoratieve vorm element" className="contactSwimmer" /> */}
        <img src="/img/banner/banner_shape04.png" alt="Decoratieve vorm element" className="rotateme" />
        <img src="/img/banner/banner_shape05.png" alt="Decoratieve vorm element" className="animation1" />
        <img src="/img/banner/banner_shape06.png" alt="Decoratieve vorm element" className="ribbonRotate" />
        <img src="/img/banner/banner_shape07.png" alt="Decoratieve vorm element" className="float-bob-x" />
      </div>
    </section>
  );
};

export default BannerOne;
